<div class="wrapper">
  <a (click)="logout($event)" href="#" *ngIf="showLogout()">
    <mat-icon>logout</mat-icon>
    Abmelden
  </a>
  <a (click)="changePassword($event)" href="#" *ngIf="showLogout()">
    <mat-icon>password</mat-icon>
    Passwort ändern
  </a>
  <a href="https://www.mess-profis.de/impressum/" target="_blank">
    <mat-icon>home_work</mat-icon>
    Impressum
  </a>
  <a href="https://www.mess-profis.de/datenschutz/" target="_blank">
    <mat-icon>lock</mat-icon>
    Datenschutz
  </a>
  <a href="https://www.mess-profis.de/bewohner" target="_blank">
    <mat-icon>question_mark</mat-icon>
    FAQ
  </a>
</div>
